<template>
	<div class="box">
		<el-container class="home-container">
			<!-- :class="{ roll: row == 1 }" -->
			<el-header :class="{ roll: roll }">
				<Header></Header>
			</el-header>
			<el-main>
				<div class="banner-wrap">
					<div class="page-container hidden-xs" style="height: 100%">
						<div :class="{
                strategicMaps_title: true,
                animated: true,
                fadeInUp: true,
              }">

						</div>
						<img class="show" src="../assets/home/005.png" alt="" />
						<video width="100%" id="video1" autoplay="" loop="" muted="" x-webkit-airplay="true"
							airplay="allow" webkit-playsinline="true" playsinline="true" class="bg-video"
							src="@/assets/vedio/vedio.mp4"></video>
					</div>
				</div>
				<div class="content">
					<div class="f2">
						<div class="f2_title" :class="{
                 strategicMaps_title: true,
                 animated: true,
                 fadeInRight: testShow0,
               }">
							牛加科技致力成为国内领先的数智化转型
							<br>及信创安全技术服务商
						</div>
						<div class="f2_content">
							<div class="content">
								<div :class="{
                      strategicMaps_title: true,
                      animated: true,
                      fadeInUp: f2bigshowl,
                    }" class="content_left">
									<div class="content_left_label">
										<div class="label">
											<p> 信创安全科技</p>
										</div>
										<div class="label2">
											<p>  围绕国产信创底座，构建内生安全、智能攻防、智能体安全与云网安全四大核心能力，形成从芯片操作系统根基加固、AI主动对抗、LLM自主行为管控到云网融合防护的全栈闭环，打造自主可控、主动免疫的安全体系，为企业数字化转型筑牢全方位安全防线。</p>
										</div>
									</div>
								</div>
								<div class="content_right" :class="{
                     strategicMaps_title: true,
                     animated: true,
                     fadeInDown: f2bigshowl,
                   }">

									<div class="content_right_label"  >
										<div class="label">
											<p> 产业数智赋能</p>
										</div>
										<div class="label2">
											<p> 利用数字科技赋能，选择特定产业通过应用云计算、大数据等先进技术手段，实现生产流程、管理模式、产品服务等全方位的数字化升级，从而提高生产效率、优化资源配置、增强市场竞争力。
											</p>
								 	</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="f6">
					  <div class="f6_content">
					    <div class="f6_title">合作伙伴</div>
					    <div
					      class="f6_content_list"
					      :class="{
					        strategicMaps_title: true,
					        animated: true,
					        fadeInUp: f2bigshowl,
					      }"
					    >
					      <div class="f6_content_list1">
					        <img src="../assets/home/组4.png" alt="" />
					        <img src="../assets/home/组5.png" alt="" />
					        <img src="../assets/home/组6.png" alt="" />
					        <img src="../assets/home/组7.png" alt="" />
							 <img src="../assets/home/组47.png" alt="" />
					      </div>
					      <div class="f6_content_list2">
					        <img src="../assets/home/组8.png" alt="" />
							 <img src="../assets/home/组9.png" alt="" />
							  <img src="../assets/home/组10.png" alt="" />
							   	<img src="../assets/home/组16.png" alt="" />  
								 <img src="../assets/home/组46.png" alt="" />
					      </div>
						   <div class="f6_content_list2">
							     <img src="../assets/home/组15.png" alt="" />
							    <img src="../assets/home/组14.png" alt="" />  
							   	<img src="../assets/home/组44.png" alt="" />  
									<img src="../assets/home/组45.png" alt="" />  
										<img src="../assets/home/组48.png" alt="" />  `	
							   </div>
					 
					    </div>
					    <div class="f6_content_list_show">
					     <img src="../assets/home/组4.png" alt="" />
					     <img src="../assets/home/组5.png" alt="" />
					     <img src="../assets/home/组6.png" alt="" />
					     <img src="../assets/home/组7.png" alt="" />
						 <img src="../assets/home/组8.png" alt="" />
						  <img src="../assets/home/组9.png" alt="" />
						   <img src="../assets/home/组10.png" alt="" />
						   <img src="../assets/home/组14.png" alt="" />  
						    <img src="../assets/home/组15.png" alt="" />
								<img src="../assets/home/组16.png" alt="" />  
								  	<img src="../assets/home/组44.png" alt="" />  
										<img src="../assets/home/组45.png" alt="" />  
					    </div>
					  </div> </div> 
				</div>

				

				<Footer></Footer>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import Footer from "@/components/Footer.vue";
	import Header from "@/components/Header.vue";
	export default {
		components: {
			Footer,
			Header
		},
		data() {
			return {
				cut: 1,
				roll: false,
				f2bigshowl: true,
			};
		},
		mounted() {
			//可以在这里面直接进行滚动条的获取
			window.addEventListener("scroll", this.handleScroll, true);
		},
		methods: {
			handleScroll(e) {
				let height = e.target.scrollTop;
				if (height !== 0) {
					this.roll = true;
				} else {
					this.roll = false;
				}
			},
			// 跳转至留言咨询
			goConsult() {
				// 新开窗口显示
				window.open(this.$router.resolve({
					path: "/consult"
				}).href);
				// this.$router.push("/consult");
			},
			// 解决方案
			goKuaJing() {
				if (this.$route.path == "/kuajing") return;
				this.$router.push("/kuajing");
			},
			goShangPiao() {
				if (this.$route.path == "/shangpiao") return;
				this.$router.push("/shangpiao");
			},
			goShangLian() {
				if (this.$route.path == "/shanglian") return;
				this.$router.push("/shanglian");
			},
			goPuHui() {
				if (this.$route.path == "/puhui") return;
				this.$router.push("/puhui");
			},
		},
	};
</script>
<style lang="scss" scoped>
	.box {
		height: 100vh;
		background-color: #f8f9fb;
	}

	.home-container {
		height: 100vh;
	}

	// 头部区域
	.el-header {
		z-index: 99999;
		width: 100vw;
		position: fixed;
		background-color: rgba(255, 255, 255, 1);

		@media only screen and (min-width: 0px) and (max-width: 1050px) {
			background: #fff;
		}

		z-index: 999;
		height: 80px !important;

		@media only screen and (min-width: 0) and (max-width: 899px) {
			height: 60px !important;
		}

		padding: 0;

		@media only screen and (min-width: 371px) and (max-width: 899px) {
			margin: 0 auto;
		}

		&.roll {
			background: #fff;
		}
	}

	// 主体区域
	.el-main {
		width: 100vw;
		padding: 0 !important;

		p {
			position: absolute;
			width: 85%;
			font-size: 14px;
			font-family: Source Han Sans SC;
			font-weight: 400;
			color: #b3b3b3;
			text-align: center;
		}
	}

	.page-container {
		position: relative;

		@media only screen and (min-width: 0) and (max-width: 899px) {
			margin-top: 60px;
		}

		div {
			position: absolute;
			top: 300px;
			left: 360px;

			@media only screen and (min-width: 0px) and (max-width: 399px) {
				width: 100vw;
				text-align: center;
				top: 22%;
				left: 0;
			}

			@media only screen and (min-width: 400px) and (max-width: 799px) {
				width: 100vw;
				text-align: center;
				top: 27%;
				left: 0;
			}

			@media only screen and (min-width: 800px) and (max-width: 899px) {
				top: 40%;
				left: 50px;
			}

			@media only screen and (min-width: 900px) and (max-width: 1250px) {
				top: 40%;
				left: 50px;
			}

			h1 {
				@media only screen and (min-width: 0px) and (max-width: 399px) {
					font-size: 22px;
				}

				@media only screen and (min-width: 400px) and (max-width: 799px) {
					font-size: 24px;
				}

				@media only screen and (min-width: 800px) and (max-width: 899px) {
					font-size: 30px;
				}

				font-size: 50px;
				font-weight: 600;
				color: #fff;
				line-height: 70px;
				margin-bottom: 26px;
				transition: all 0.3s ease;
			}

			h5 {
				@media only screen and (min-width: 0px) and (max-width: 799px) {
					display: none;
				}

				font-size: 24px;
				line-height: 28px;
				color: #dddfe7;
				font-weight: 500;
			}
		}

		.show {
			@media only screen and (min-width: 800px) and (max-width: 2580px) {
				display: none;
			}

			width: 100%;
		}

		video {
			@media only screen and (min-width: 0px) and (max-width: 799px) {
				display: none;
			}
		}
	}

	.content {
		box-sizing: border-box;
		padding-top: 80px;
    background-color: #fff;
		// 二楼
		.f2 {
			width: 100vw;

			.f2_title {
				display: flex;
				justify-content: center;
				text-align: center;
				width: 100vw;
				margin: 50px 0 50px 0;
				font-size: 32px;

				@media only screen and (min-width: 0px) and (max-width: 899px) {
					font-size: 24px;
				}

				font-weight: 600;
				color: #34363d;
				user-select: none;
			}

			.f2_content {
				display: flex;
				justify-content: center;
				width: 100%;
				margin-bottom: 80px;

				// height: 326px;
				.content {
					display: flex;

					@media only screen and (min-width: 0) and (max-width: 950px) {
						justify-content: center;
						display: flow;
					}

					width: 1250px;
					height: 100%;
					.content_left {
						box-sizing: border-box;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						width: 50%;
						height: 43.75rem;
						background: url(@/assets/home/nj-big-01.png) no-repeat;
						background-size: 100% 100%;

						@media only screen and (min-width: 0) and (max-width: 950px) {
						 width: 100%;
						 height: 33.75rem;
						}
							.content_left_label {
								display: flow;

								@media only screen and (min-width: 0px) and (max-width: 950px) {
								 
								}

								@media only screen and (min-width: 0px) and (max-width: 1250px) {
									margin-top: 20px;
								}

								@media only screen and (min-width: 0) and (max-width: 949px) {
									flex-direction: column;
								}

								// height: 21px;
								.label {
									width: 380px;
									position: relative;
									height: 21px;
									margin-right: 15px;

									p {
										position: absolute;
										top: 160px;
										left: 35px;
										height: 21px;
										font-size: 32px;
										height: 21px;
										font-family: SourceHanSansSC-Medium,
										SourceHanSansSC;
										font-weight: 500;
										color: #fff;
									}
								}

								.label2 {
									width: 480px;
									position: relative;
									height: 21px;
									margin-right: 15px;

									@media only screen and (min-width: 0) and (max-width: 949px) {
										 
										}

									p {
										position: absolute;
										top: 250px;text-align: left;
										left: 90px;
										height: 21px;
						 			   font-size: 22px;
										height: 21px;
										font-family: SourceHanSansSC-Medium,
										SourceHanSansSC;
										font-weight: 500;
										color: #fff;
										@media only screen and (min-width: 0) and (max-width: 949px) {
											left: 40px;
											 font-size: 18px;
										}
							  }
								}
							}
						 
					}
					 
					.content_right {
						box-sizing: border-box;
						display: flex;
						margin-top: 30px;
						flex-direction: column;
						justify-content: space-between;
						padding: 0 50px 0 39px;
						width: 40%;
						margin-bottom: 30px;
						margin-right: 30px;
						background: url(@/assets/home/nj-sm-02.png) no-repeat;
						background-size: 100% 100%;
						
						@media only screen and (min-width: 0) and (max-width: 950px) {
						 width: 100%;
						 height: 33.75rem;
						}
						p {
							font-size: 16px;
							font-weight: 400;
							color: #5e636e;
							line-height: 36px;
							font-family: 微软雅黑;
						}

						.content_right_label {
							display: flow;
							.label {
								width: 280px;
								position: relative;
								height: 21px;
								margin-right: 15px;
								p {
									position: absolute;
									top: 160px;
									left: 143px;
									height: 21px;
									font-size: 30px;
 
									height: 21px;
									font-family: SourceHanSansSC-Medium,
									SourceHanSansSC;
									font-weight: 500;
									color: #fff;
								}
							}

							.label2 {
								width: 380px;
								position: relative;
			 				height: 21px;
								margin-right: 15px;

							 

								p {
									position: absolute;
									top: 250px;
									left: 40px;
									height: 21px;
									font-size: 18px;
 

									height: 21px;
									font-family: SourceHanSansSC-Medium,
									SourceHanSansSC;
									font-weight: 500;
									color: #fff;
								}
							}
						}
					}
				}
			}
		}

		// 三楼
		.f3 {
			width: 100vw;

			.f3_title {
				display: flex;
				justify-content: center;
				width: 100vw;
				margin: 160px 0 55px 0;

				@media only screen and (min-width: 0px) and (max-width: 799px) {
					margin: 100px 0 55px 0;
				}

				font-weight: 600;
				color: #34363d;
				user-select: none;
				font-size: 32px;

				@media only screen and (min-width: 0px) and (max-width: 899px) {
					font-size: 24px;
				}
			}

			.f3_ul {
				box-sizing: border-box;
				padding: 0 25px;
				display: flex;
				justify-content: center;
				width: 100vw;

				ul {
					width: 35vw;

					@media only screen and (min-width: 0px) and (max-width: 799px) {
						width: 100vw;
					}

					@media only screen and (min-width: 800px) and (max-width: 999px) {
						width: 80vw;
					}

					@media only screen and (min-width: 1000px) and (max-width: 1319px) {
						width: 70vw;
					}

					@media only screen and (min-width: 1320px) and (max-width: 1535px) {
						width: 60vw;
					}

					display: flex;
					justify-content: space-between;

					li {
						display: flex;
						justify-content: center;
						width: 110px;
						height: 50px;
						font-size: 22px;

						@media only screen and (min-width: 0px) and (max-width: 1250px) {
							font-size: 18px;
							height: 40px;
							width: 90px;
						}

						font-family: SourceHanSansSC-Medium,
						SourceHanSansSC;
						font-weight: 500;
						color: #666666;
						cursor: pointer;

						&.active2 {
							color: #219bbb;
							border-bottom: 2px solid #2e59a1;
						}
					}
				}
			}

			.f3_content {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 100vw;
				height: 600px;

				@media only screen and (min-width: 0px) and (max-width: 1040px) {
					height: 300px;
				}

				// background-color: #f00;
				background: url(@/assets/home/图层0.png) no-repeat;
				background-size: cover;

				.f3_content_left {
					width: 480px;
					height: 500px;
					margin-top: -39px;

					@media only screen and (min-width: 0px) and (max-width: 1040px) {
						display: none;
					}

					img {
						width: 480px;
						// @media only screen and (min-width: 1041px) and (max-width: 1520px) {
						//   width: 430px;
						// }
						// height: 450px;
					}
				}

				.f3_content_right {
					width: 340px;
					margin-left: 150px;

					@media only screen and (min-width: 0px) and (max-width: 1040px) {
						margin: 0 auto;
					}

					h3 {
						font-size: 24px;
						color: #000;
						font-weight: 500;
						margin-bottom: 10px;
					}

					h5 {
						font-size: 16px;
						font-weight: 400;
						margin-bottom: 40px;
						line-height: 26px;
					}

					.f3_content_right_btn {
						display: flex;
						justify-content: center;
						align-items: center;
						width: 140px;
						height: 30px;
						color: #219bbb;
						font-size: 16px;
						border: 1px solid #2e59a1;
						border-radius: 3px;
						cursor: pointer;
					}
				}

				.f3_content_right .f3_content_right_btn:hover {
					background: rgba(4, 30, 80, 0.8);
					color: #fff;
					border: 1px solid #fff;
					border-radius: 3px;
				}
			}

			.f3_ul ul li:hover {
				color: #219bbb;
				// border-bottom: 2px solid #2e59a1;
			}
		}

		// 四楼
		.f4 {
			width: 100vw;

			.f4_title {
				display: flex;
				justify-content: center;
				width: 100vw;
				margin: 160px 0 50px 0;
				font-weight: 600;
				color: #34363d;
				user-select: none;
				font-size: 32px;

				@media only screen and (min-width: 0px) and (max-width: 899px) {
					font-size: 24px;
				}
			}

			.f4_comtent {
				display: flex;
				justify-content: center;
				width: 100vw;

				// @media only screen and (min-width: 899) and (max-width: 1680px) {
				//   width: 20vw;
				// }
				// background-color: #f00;
				// height: 645px;
				img {
					@media only screen and (min-width: 0) and (max-width: 600px) {
						width: 100%;
					}

					// 小屏
					@media only screen and (min-width: 601px) and (max-width: 899px) {
						width: 80%;
					}

					// 小屏
					@media only screen and (min-width: 900px) and (max-width: 1535px) {
						width: 60%;
					}

					// 中屏
					@media only screen and (min-width: 1536px) and (max-width: 1900px) {
						width: 60%;
					}

					// 大屏
					@media only screen and (min-width: 1901px) and (max-width: 2580px) {
						width: 65%;
					}
				}
			}
		}

		// 五楼
		.f5 {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			width: 100vw;
			height: 250px;

			@media only screen and (min-width: 0) and (max-width: 900px) {
				height: 200px;
			}

			@media only screen and (min-width: 0) and (max-width: 1230px) {
				margin-top: 60px;
			}

			opacity: 1;
			margin-top: 110px;
			background: url(@/assets/home/组39.png) no-repeat;
			background-size: cover;

			.f5_comtent {
				display: flex;
				flex-direction: column;
				justify-content: space-evenly;
				align-items: center;
				height: 100%;

				h3 {
					font-size: 38px;
					font-weight: 600;
					color: #fff;
					user-select: none;

					@media only screen and (min-width: 0) and (max-width: 899px) {
						font-size: 28px;
					}
				}

				.btn {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 150px;
					height: 30px;
					font-size: 16px;
					border-radius: 4px;
					color: #184a98;
					font-weight: 500;
					background-color: #fff;
					cursor: pointer;
				}
			}
		}
	}

	::-webkit-scrollbar {
		/*隐藏滚轮*/
		display: none;
	}

	// 动画
	@keyframes move-right1 {
		0% {
			bottom: 0px;
		}

		100% {
			bottom: 70%;
		}
	}

	@keyframes move-right2 {
		0% {
			bottom: 0px;
		}

		100% {
			bottom: 50%;
		}
	}

	@keyframes move-right3 {
		0% {
			bottom: 0px;
		}

		100% {
			bottom: 100%;
		}
	}

	@keyframes move-right4 {
		0% {
			bottom: 0px;
		}

		100% {
			bottom: 30%;
		}
	}

	@keyframes move-right5 {
		0% {
			bottom: 0px;
		}

		100% {
			bottom: 90%;
		}
	}

	@keyframes move-right11 {
		0% {
			top: 0px;
		}

		100% {
			top: 31%;
		}
	}

	@keyframes move-right12 {
		0% {
			top: 0px;
		}

		100% {
			top: 10%;
		}
	}

	@keyframes move-right13 {
		0% {
			top: 0px;
		}

		100% {
			top: -5%;
		}
	}

	@keyframes move-right14 {
		0% {
			top: 0px;
		}

		100% {
			top: 10%;
		}
	}

	@keyframes move-right15 {
		0% {
			top: 0px;
		}

		100% {
			top: 33%;
		}
	}

	// -=------------------------------------
	@keyframes move-right21 {
		0% {
			bottom: 0px;
		}

		100% {
			bottom: 62%;
		}
	}

	@keyframes move-right22 {
		0% {
			bottom: 0px;
		}

		100% {
			bottom: 88%;
		}
	}

	@keyframes move-right23 {
		0% {
			bottom: 0px;
		}

		100% {
			bottom: 79%;
		}
	}

	@keyframes move-right24 {
		0% {
			bottom: 0px;
		}

		100% {
			bottom: 43%;
		}
	}
	.f6 {
	  width: 100vw;
	  box-sizing: border-box;
	  padding: 10px 0 200px 0;
	  background-color: #fff;
	  .f6_title {
	    display: flex;
	    justify-content: center;
	    width: 100vw;
	    font-size: 32px;
	    @media only screen and (min-width: 0px) and (max-width: 899px) {
	      font-size: 24px;
	    }
	    font-weight: 600;
	    color: #34363d;
	    user-select: none;
	    margin-bottom: 55px;
	  }
	  .f6_content_list {
	    width: 65%;
	    // height: 180px;
	    margin: 0 auto;
	    @media only screen and (min-width: 0px) and (max-width: 1100px) {
	      display: none;
	    }
	    .f6_content_list1 {
	      box-sizing: border-box;
	      display: flex;
	      justify-content: space-evenly;
	      padding: 10px;
	      width: 100%;
	      height: 100px;
	      img {
	        width: 200px;
	        height: 80px;
	      }
	    }
	    .f6_content_list2 {
	      display: flex;
	      justify-content: space-evenly;
	      img {
	        width: 200px;
	        height: 80px;
	      }
	    }
		.f6_content_list3 {
		  display: flex;
		  justify-content: space-evenly;
		  img {
		    width: 200px;
		    height: 80px;
		  }
		}
	  }
	  .f6_content_list_show {
	    @media only screen and (min-width: 1110px) and (max-width: 2580px) {
	      display: none;
	    }
	    // width: 100%;
	    text-align: center;
	    img {
	      @media only screen and (min-width: 330px) and (max-width: 480px) {
	        width: 160px;
	      }
	      @media only screen and (min-width: 0px) and (max-width: 329px) {
	        width: 140px;
	      }
	      width: 200px;
	    }
	  }
	}
</style>
